import {
  EMPTY_ARRAY,
  GET,
  request,
  useUserContext,
  type ISchedule,
  type MinimalSubscriptionResponse,
} from '@talos/kyoko';
import { useQuery } from '@tanstack/react-query';
import type { CustomerMarginConfiguration } from './types';

export const CUSTOMER_MARGIN_CONFIGURATION_PATH = '/customer-margin-configurations';

type QueryOptions = {
  enabled?: boolean;
};

export function useFundingSchedulesQuery({ enabled = true }: QueryOptions = {}) {
  const { orgApiEndpoint } = useUserContext();

  return useQuery<ISchedule[]>({
    queryKey: ['funding-schedules', orgApiEndpoint],
    enabled,
    queryFn: () =>
      // Customer margin configs store funding schedules by name, so load schedules separately for the drawer dropdown.
      request<MinimalSubscriptionResponse<ISchedule>>(GET, `${orgApiEndpoint}/schedules`)
        .then(response => response.data)
        .catch(() => EMPTY_ARRAY),
  });
}

export function useCustomerMarginConfigurationsQuery({ enabled = true }: QueryOptions = {}) {
  const { orgApiEndpoint } = useUserContext();

  return useQuery<CustomerMarginConfiguration[]>({
    queryKey: ['customer-margin-configurations', orgApiEndpoint],
    enabled,
    queryFn: () =>
      request<MinimalSubscriptionResponse<CustomerMarginConfiguration>>(
        GET,
        `${orgApiEndpoint}${CUSTOMER_MARGIN_CONFIGURATION_PATH}`
      ).then(response => response.data),
  });
}
